import { ServiceDefinition } from '@pershing/pershing-core';

export class ModernRateBoardServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;

    uri: string = 'rateboard';
    version: string = 'v1';
    family: string = 'netxinvestor';
    appName: string = 'rateboard-svc';
    serviceName: string = 'app';
    mnemonic: string = 'nxc';

    static getInstance(): ServiceDefinition {
        if (!ModernRateBoardServiceDefinition.instance) {
            ModernRateBoardServiceDefinition.instance = new ModernRateBoardServiceDefinition();
        }
        return ModernRateBoardServiceDefinition.instance;
    }
    private constructor() {}
}
